import { ICenterFiveStarSurveyType } from "./center-five-star-survey-type";

﻿﻿export interface INetworkFiveStarSurveyType {

      networkFiveStarSurveyType: ICenterFiveStarSurveyType;
}
